/* ss-checkout-popup.js — SeatShield checkout-intercept upsell popup
 *
 * Intercepts clicks on:
 *   - #SsCheckoutBtn (SS Cart Drawer Checkout link)
 *   - The /cart page checkout form submit
 *
 * If a popup_offer matches the current cart and has un-added items, shows the
 * popup. Otherwise lets the checkout navigate proceed unmodified.
 *
 * Spec: docs/specs/ss-checkout-popup.md §4, §7
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('SsCheckoutPopupData');
  if (!dataEl) return;

  var config;
  try { config = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!config || !config.enabled) return;

  // Seed cart_state from the initial JSON payload so resolveOffer() has
  // populated sets on page load. refreshCartState() keeps it current after
  // subsequent cart mutations via SRA.
  config.cart_state = config.cart_state || { product_ids_in_cart: [], collection_ids_in_cart: [] };

  var popupEl = document.getElementById('SsCheckoutPopup');
  if (!popupEl) return;

  var overlayEl        = popupEl.querySelector('[data-ss-popup-overlay]');
  var panelEl          = popupEl.querySelector('.ss-checkout-popup__panel');
  var titleEl          = document.getElementById('SsCheckoutPopupTitle');
  var subtitleEl       = document.getElementById('SsCheckoutPopupSubtitle');
  var itemsContainerEl = document.getElementById('SsCheckoutPopupItems');
  var continueBtn      = document.getElementById('SsCheckoutPopupContinue');

  var maxHeightVh      = parseInt(popupEl.dataset.maxHeightVh, 10) || 90;
  var mobileBreakpoint = parseInt(popupEl.dataset.mobileBreakpoint, 10) || 480;

  var lastFocus = null;
  var _trapHandler = null;

  // ────────────────────────────────────────────────────────────────────────────
  // TRIGGER WIRING
  // ────────────────────────────────────────────────────────────────────────────

  // Cart drawer Checkout button
  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('#SsCheckoutBtn');
    if (!checkoutBtn) return;
    e.preventDefault();
    maybeShowPopup();
  });

  // Standalone /cart page checkout form
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('action') !== '/cart') return;
    if (!form.querySelector('[name="checkout"]')) return;
    e.preventDefault();
    maybeShowPopup();
  }, true);

  // ────────────────────────────────────────────────────────────────────────────
  // MATCH RESOLUTION
  // ────────────────────────────────────────────────────────────────────────────

  function maybeShowPopup() {
    // Resolve offer using Liquid-rendered cart_state (has collection IDs).
    var offer = resolveOffer();
    if (!offer) { proceedToCheckout(); return; }

    // Fetch /cart.js only for the "already in cart" item filter — product_id
    // is all we need here and cart.js reliably returns it.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartProductIds = new Set(cart.items.map(function (i) { return String(i.product_id); }));
        var visibleItems = offer.offered_items.filter(function (item) {
          return !cartProductIds.has(String(item.product_id));
        });

        if (!visibleItems.length) { proceedToCheckout(); return; }

        openPopup(offer, visibleItems);
      })
      .catch(function () { proceedToCheckout(); });
  }

  function resolveOffer() {
    // Use Liquid-rendered cart_state for matching.  /cart.js doesn't return
    // collection memberships, so product-to-collection cross-referencing is
    // done server-side and embedded in the section JSON at render time.
    // cart_state is kept current by the cart drawer passing the re-rendered
    // ss-checkout-popup section HTML to SsCheckoutPopup.refreshCartState()
    // after every cart mutation via the Shopify Sections Rendering API.
    var cartState = config.cart_state || {};
    var cartProductIds   = new Set((cartState.product_ids_in_cart   || []).map(String));
    var cartCollectionIds = new Set((cartState.collection_ids_in_cart || []).map(String));

    var offers = config.offers || [];
    for (var i = 0; i < offers.length; i++) {
      var offer = offers[i];
      if (!offer.enabled) continue;

      // An offer with NO targeting configured matches every cart (2026-06-12:
      // parity fix ported from F3 — empty targeting means "show for all carts"
      // instead of silently never firing).
      var hasTargeting = offer.targeted_product_ids.length > 0 ||
                         offer.targeted_collection_ids.length > 0;
      if (!hasTargeting) return offer;

      var productMatch = offer.targeted_product_ids.some(function (id) {
        return cartProductIds.has(String(id));
      });
      var collectionMatch = offer.targeted_collection_ids.some(function (id) {
        return cartCollectionIds.has(String(id));
      });

      if (!productMatch && !collectionMatch) continue;
      return offer;
    }
    return null;
  }

  // ────────────────────────────────────────────────────────────────────────────
  // POPUP OPEN / CLOSE
  // ────────────────────────────────────────────────────────────────────────────

  function openPopup(offer, items) {
    lastFocus = document.activeElement;

    // Apply overlay opacity from section setting
    var opacity = parseFloat(popupEl.dataset.overlayOpacity || '0.5');
    if (overlayEl) overlayEl.style.background = 'rgba(0,0,0,' + opacity + ')';

    // Apply max-height
    if (panelEl) {
      panelEl.style.maxHeight = maxHeightVh + 'vh';
      if (window.innerWidth <= mobileBreakpoint) {
        panelEl.style.maxHeight = '100dvh';
      }
    }

    // Populate header
    var title    = offer.title    || config.defaults.title    || '';
    var subtitle = offer.subtitle || config.defaults.subtitle || '';
    var contText = offer.continue_button_text || config.defaults.continue_button_text || 'CONTINUE';

    if (titleEl) titleEl.textContent = title;
    if (subtitleEl) {
      subtitleEl.textContent = subtitle;
      subtitleEl.hidden = !subtitle;
    }
    if (continueBtn) continueBtn.textContent = contText;

    // Render item rows
    if (itemsContainerEl) {
      itemsContainerEl.innerHTML = '';
      items.forEach(function (item) {
        itemsContainerEl.appendChild(buildItemRow(item));
      });
    }

    popupEl.hidden = false;
    popupEl.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';

    trapFocus(popupEl);

    var closeBtn = popupEl.querySelector('[data-ss-popup-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closePopup() {
    popupEl.hidden = true;
    popupEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    releaseFocus();
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
  }

  // ────────────────────────────────────────────────────────────────────────────
  // ITEM ROW BUILDER
  // ────────────────────────────────────────────────────────────────────────────

  function buildItemRow(item) {
    var defaultVariant = item.variants.find(function (v) { return v.id === item.default_variant_id; })
      || item.variants.find(function (v) { return v.available; })
      || item.variants[0];

    var hasOptions = item.options && item.options.length > 0
      && !(item.options.length === 1 && item.options[0].name === 'Title' && item.options[0].values.length === 1 && item.options[0].values[0] === 'Default Title');

    var row = document.createElement('div');
    row.className = 'ss-popup-item';
    row.setAttribute('role', 'listitem');
    row.setAttribute('data-product-id', item.product_id);

    // Serialize variant data for update logic
    row.setAttribute('data-variants', JSON.stringify(item.variants));

    // Image
    var imgWrap = document.createElement('div');
    imgWrap.className = 'ss-popup-item__image-wrap';
    if (item.featured_image) {
      var img = document.createElement('img');
      img.className = 'ss-popup-item__image';
      img.setAttribute('data-ss-popup-item-image', '');
      img.src = item.featured_image;
      img.alt = item.product_title || '';
      img.loading = 'lazy';
      imgWrap.appendChild(img);
    }
    row.appendChild(imgWrap);

    // Body
    var body = document.createElement('div');
    body.className = 'ss-popup-item__body';

    var titleEl = document.createElement('a');
    titleEl.className = 'ss-popup-item__title';
    titleEl.href = '/products/' + item.product_handle;
    titleEl.textContent = item.product_title || '';
    body.appendChild(titleEl);

    // Price row
    var priceRow = document.createElement('div');
    priceRow.className = 'ss-popup-item__price-row';

    var priceEl = document.createElement('span');
    priceEl.className = 'ss-popup-item__price';
    priceEl.setAttribute('data-ss-popup-price', '');
    priceEl.textContent = formatMoney(defaultVariant.price);
    priceRow.appendChild(priceEl);

    if (defaultVariant.compare_at_price && defaultVariant.compare_at_price > defaultVariant.price) {
      var compareEl = document.createElement('span');
      compareEl.className = 'ss-popup-item__compare-price';
      compareEl.setAttribute('data-ss-popup-compare', '');
      compareEl.textContent = formatMoney(defaultVariant.compare_at_price);
      priceRow.appendChild(compareEl);
    }
    body.appendChild(priceRow);

    // Badge
    if (item.badge_text) {
      var badge = document.createElement('div');
      badge.className = 'ss-popup-item__badge';
      badge.textContent = item.badge_text;
      body.appendChild(badge);
    }

    // Controls row
    var controls = document.createElement('div');
    controls.className = 'ss-popup-item__controls';

    // Variant select (only when non-default variants)
    if (hasOptions) {
      var select = document.createElement('select');
      select.className = 'ss-popup-item__variant-select ss-popup-variant-select';
      select.setAttribute('aria-label', 'Select variant');
      item.variants.forEach(function (v) {
        var opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        if (!v.available) opt.disabled = true;
        if (v.id === defaultVariant.id) opt.selected = true;
        select.appendChild(opt);
      });
      controls.appendChild(select);
    }

    // Qty stepper
    var stepper = document.createElement('div');
    stepper.className = 'ss-popup-item__qty-stepper';

    var decrBtn = document.createElement('button');
    decrBtn.type = 'button';
    decrBtn.className = 'ss-popup-item__qty-btn';
    decrBtn.setAttribute('data-ss-popup-decrement', '');
    decrBtn.setAttribute('aria-label', 'Decrease quantity');
    decrBtn.textContent = '−';
    stepper.appendChild(decrBtn);

    var qtyInput = document.createElement('input');
    qtyInput.type = 'number';
    qtyInput.className = 'ss-popup-item__qty-input ss-popup-qty-input';
    qtyInput.min = '1';
    qtyInput.value = item.default_quantity || 1;
    qtyInput.setAttribute('inputmode', 'numeric');
    qtyInput.setAttribute('aria-label', 'Quantity');
    stepper.appendChild(qtyInput);

    var incrBtn = document.createElement('button');
    incrBtn.type = 'button';
    incrBtn.className = 'ss-popup-item__qty-btn';
    incrBtn.setAttribute('data-ss-popup-increment', '');
    incrBtn.setAttribute('aria-label', 'Increase quantity');
    incrBtn.textContent = '+';
    stepper.appendChild(incrBtn);

    controls.appendChild(stepper);

    // Add button
    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'ss-popup-item__add-btn ss-popup-add-btn';
    addBtn.setAttribute('data-ss-popup-add', '');
    addBtn.setAttribute('data-variant-id', defaultVariant.id);
    addBtn.setAttribute('aria-label', 'Add to cart');
    addBtn.setAttribute('aria-live', 'polite');
    if (!defaultVariant.available) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
    } else {
      addBtn.textContent = 'ADD';
    }
    controls.appendChild(addBtn);

    body.appendChild(controls);

    // Inline error placeholder
    var errorEl = document.createElement('div');
    errorEl.className = 'ss-popup-item__error';
    errorEl.setAttribute('aria-live', 'polite');
    errorEl.hidden = true;
    body.appendChild(errorEl);

    row.appendChild(body);
    return row;
  }

  // ────────────────────────────────────────────────────────────────────────────
  // EVENT DELEGATION on popupEl
  // ────────────────────────────────────────────────────────────────────────────

  popupEl.addEventListener('click', function (e) {
    // Close / overlay / continue
    if (e.target.closest('[data-ss-popup-close]') || e.target.closest('[data-ss-popup-continue]')) {
      proceedToCheckout();
      return;
    }
    if (e.target.matches('[data-ss-popup-overlay]')) {
      proceedToCheckout();
      return;
    }

    // Qty stepper
    var row = e.target.closest('.ss-popup-item');
    if (!row) return;
    var input = row.querySelector('.ss-popup-qty-input');

    if (e.target.closest('[data-ss-popup-decrement]') && input) {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
      return;
    }
    if (e.target.closest('[data-ss-popup-increment]') && input) {
      input.value = parseInt(input.value, 10) + 1;
      return;
    }

    // ADD
    var addBtn = e.target.closest('[data-ss-popup-add]');
    if (!addBtn || addBtn.disabled || addBtn.classList.contains('is-added')) return;
    handleAdd(addBtn, row);
  });

  // Variant select → update price, image, add-btn availability
  popupEl.addEventListener('change', function (e) {
    var select = e.target.closest('.ss-popup-variant-select');
    if (!select) return;
    var row = select.closest('.ss-popup-item');
    if (!row) return;
    updateRowVariant(row, parseInt(select.value, 10));
  });

  // Qty input blur → clamp to [1, ...]
  popupEl.addEventListener('blur', function (e) {
    var input = e.target.closest('.ss-popup-qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) input.value = 1;
  }, true);

  // ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !popupEl.hidden) proceedToCheckout();
  });

  // ────────────────────────────────────────────────────────────────────────────
  // VARIANT CHANGE
  // ────────────────────────────────────────────────────────────────────────────

  function updateRowVariant(row, variantId) {
    var variants;
    try { variants = JSON.parse(row.dataset.variants || '[]'); } catch (e) { variants = []; }
    var v = variants.find(function (x) { return x.id === variantId; });
    if (!v) return;

    var addBtn = row.querySelector('[data-ss-popup-add]');
    if (addBtn) {
      addBtn.dataset.variantId = v.id;
      if (v.available) {
        addBtn.disabled = false;
        if (!addBtn.classList.contains('is-added')) addBtn.textContent = 'ADD';
      } else {
        addBtn.disabled = true;
        if (!addBtn.classList.contains('is-added')) addBtn.textContent = 'Unavailable';
      }
    }

    var priceEl = row.querySelector('[data-ss-popup-price]');
    if (priceEl) priceEl.textContent = formatMoney(v.price);

    var compareEl = row.querySelector('[data-ss-popup-compare]');
    if (compareEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (v.featured_image) {
      var imgEl = row.querySelector('[data-ss-popup-item-image]');
      if (imgEl) imgEl.src = v.featured_image;
    }
  }

  // ────────────────────────────────────────────────────────────────────────────
  // ADD TO CART
  // ────────────────────────────────────────────────────────────────────────────

  function handleAdd(addBtn, row) {
    var select   = row.querySelector('.ss-popup-variant-select');
    var variantId = select ? parseInt(select.value, 10) : parseInt(addBtn.dataset.variantId, 10);
    var qtyInput = row.querySelector('.ss-popup-qty-input');
    var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;

    if (!variantId) return;

    addBtn.classList.add('is-loading');
    addBtn.textContent = '…';
    addBtn.disabled = true;

    var errorEl = row.querySelector('.ss-popup-item__error');
    if (errorEl) errorEl.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return r.json();
      })
      .then(function () {
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-added');
        addBtn.textContent = 'Added ✓';
        // Refresh cart drawer in background so it's current when popup closes
        if (window.SsCartDrawer && typeof window.SsCartDrawer.refresh === 'function') {
          window.SsCartDrawer.refresh();
        }
      })
      .catch(function (err) {
        addBtn.classList.remove('is-loading');
        addBtn.disabled = false;
        addBtn.textContent = 'ADD';
        if (errorEl) {
          errorEl.textContent = err.message || 'Unavailable — try another option';
          errorEl.hidden = false;
        }
      });
  }

  // ────────────────────────────────────────────────────────────────────────────
  // CHECKOUT PROCEED
  // ────────────────────────────────────────────────────────────────────────────

  function proceedToCheckout() {
    closePopup();
    window.location.href = '/checkout';
  }

  // ────────────────────────────────────────────────────────────────────────────
  // FOCUS TRAP
  // ────────────────────────────────────────────────────────────────────────────

  function trapFocus(el) {
    var focusable = getFocusable(el);
    if (focusable.length) focusable[0].focus();
    _trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      var f = getFocusable(el);
      if (!f.length) return;
      if (e.shiftKey) {
        if (document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      } else {
        if (document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    };
    document.addEventListener('keydown', _trapHandler);
  }

  function releaseFocus() {
    if (_trapHandler) { document.removeEventListener('keydown', _trapHandler); _trapHandler = null; }
  }

  function getFocusable(el) {
    return Array.from(el.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (n) { return n.offsetParent !== null; });
  }

  // ────────────────────────────────────────────────────────────────────────────
  // MONEY FORMATTER
  // ────────────────────────────────────────────────────────────────────────────

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
        return window.Shopify.formatMoney(cents, fmt);
      } catch (e) { /* fall through */ }
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // ────────────────────────────────────────────────────────────────────────────
  // PUBLIC API — called by ss-cart-drawer.js after every cart mutation so
  // config.cart_state stays current without a full page reload.
  // ────────────────────────────────────────────────────────────────────────────
  window.SsCheckoutPopup = window.SsCheckoutPopup || {};

  // Receives the re-rendered ss-checkout-popup section HTML from the Shopify
  // Sections Rendering API and updates config.cart_state in place.
  window.SsCheckoutPopup.refreshCartState = function (sectionHtml) {
    if (!sectionHtml) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = sectionHtml;
    var freshDataEl = tmp.querySelector('#SsCheckoutPopupData');
    if (!freshDataEl) return;
    try {
      var freshConfig = JSON.parse(freshDataEl.textContent);
      if (freshConfig && freshConfig.cart_state) {
        config.cart_state = freshConfig.cart_state;
      }
    } catch (e) { /* ignore parse errors */ }
  };

})();
